const pruebas = window.location.host === 'localhost:3000';
const PRECIOS = pruebas ? 'SicaiWeb/api/Public/Paquetes' : 'sicaiwebsys/SicaiWeb/api/Public/Paquetes';
const PRECIOS_TIMBRE = pruebas ? 'apiAdmin/api/Public/PaquetesWS' : 'Administrador/apiAdmin/api/Public/PaquetesWS';
const SOLICITUDPRUEBAS = pruebas ? 'apiAdmin/api/Public/InfoWS' : 'Administrador/apiAdmin/api/Public/InfoWS';
const EnvioRecuracion = pruebas ? 'apiAdmin/api/Public/RecuperacionSICAI' : 'Administrador/apiAdmin/api/Public/RecuperacionSICAI';

const URL = {PRECIOS, PRECIOS_TIMBRE, SOLICITUDPRUEBAS, EnvioRecuracion};

export default URL;
